/* Gauntlet Gallery — scroll reveal controller.
   Finds every content section below the hero, assigns alternating
   left/right/up reveal classes, and toggles .is-visible via IntersectionObserver
   once the section scrolls into view. */

(function () {
  if (window.__ggScrollRevealInit) return;
  window.__ggScrollRevealInit = true;

  // Respect motion preference
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function init() {
    var main = document.querySelector('main') || document.body;
    // Collect top-level sections that Shopify wraps for us
    var sections = Array.prototype.slice.call(
      main.querySelectorAll(':scope > div > .shopify-section, :scope > .shopify-section, .shopify-section')
    );
    // Dedupe
    sections = Array.from(new Set(sections));
    if (!sections.length) return;

    // Skip obvious chrome: header, menu drawer, popups, overlay-group, wishlist, exit-popup
    var skip = /header|overlay|drawer|popup|announcement|wishlist|aside|sidebar|exit/i;

    // Detect hero: the FIRST section that contains a gauntlet-hero-slider or gauntlet-artist-hero
    var heroFound = false;
    var heroEl = null;
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      var cls = (s.className || '') + ' ' + (s.id || '');
      if (skip.test(cls)) continue;
      if (s.querySelector('.gg-hero-slider, .ga-artist-hero, [class*="hero-slider"], [class*="artist-hero"]')) {
        heroEl = s;
        heroFound = true;
        break;
      }
    }

    // All content sections AFTER the hero (or all content if no hero) get reveal
    var contentSections = [];
    var pastHero = !heroFound;
    sections.forEach(function (s) {
      var cls = (s.className || '') + ' ' + (s.id || '');
      if (skip.test(cls)) return;
      if (!pastHero) {
        if (s === heroEl) { pastHero = true; }
        return;
      }
      contentSections.push(s);
    });

    if (!contentSections.length) return;

    // Apply alternating reveal direction. Last section → slide up.
    contentSections.forEach(function (s, idx) {
      s.classList.add('gg-reveal');
      if (idx === contentSections.length - 1) {
        s.classList.add('gg-reveal--up');
      } else if (idx % 2 === 0) {
        s.classList.add('gg-reveal--left');
      } else {
        s.classList.add('gg-reveal--right');
      }
    });

    // IntersectionObserver to trigger reveal
    if (!('IntersectionObserver' in window)) {
      contentSections.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, {
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.01
    });
    contentSections.forEach(function (s) { io.observe(s); });

    // Reveal any section already near the viewport on initial load.
    // Also a hard failsafe at 2.5 s — shows everything if scroll is blocked.
    function revealInView() {
      var vh = window.innerHeight;
      contentSections.forEach(function (s) {
        if (s.classList.contains('is-visible')) return;
        var rect = s.getBoundingClientRect();
        if (rect.top < vh * 1.5) { s.classList.add('is-visible'); io.unobserve(s); }
      });
    }
    revealInView();
    setTimeout(function () {
      contentSections.forEach(function (s) { s.classList.add('is-visible'); });
    }, 2500);

    document.documentElement.classList.add('gg-scroll-ui-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when Shopify editor injects new sections
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });
})();
